import "./ClientFooter.css";

function ClientFooter() {
  return (
    <div className="footer">
      <div className="footer-inner">
        <div className="info">
          <p className="copyright">
            Giấy phép cung cấp dịch vụ trò chơi điện tử G1 trên mạng: 177/GP-PTTH & TTĐT
          </p>
        </div>
      </div>
    </div>
  );
}

export default ClientFooter;
